import classNames from 'classnames';
import map from 'lodash/map';
import moment from 'moment';

import LinkButton from 'src/app/components/Elements/Button/LinkButton';
import { Card, CardItem } from 'src/app/components/Elements/Card';
import { ToolTip } from 'src/app/components/Elements/ToolTip';
import { AccountPageAddDependent } from 'src/app/router/paths';
import type { PatientDetails } from 'src/app/types';
import { formatPhoneNumber } from 'src/app/utils/accountUtils';
import { DEFAULT_BIRTHDATE } from 'src/consts';

import { NoFamilyPrompt } from './NoFamilyPrompt';
import styles from './styles.module.scss';

const FamilyMemberTooltip = () => (
  <div className={styles.toolTipContainer}>
    <ToolTip
      anchorText="Why should you add family members?"
      header="Why add family members?"
      body="By adding a family member to your account, you can manage your family’s medications all in one place and bundle free same-day delivery."
      analyticTip="Add Family Member"
    />
  </div>
);

interface FamilyMemberSectionProps {
  patients: PatientDetails[];
  email: string;
  phone: string;
  showFamilyPrompt: boolean;
}

export const FamilyMemberSection = ({ showFamilyPrompt, patients, email, phone }: FamilyMemberSectionProps) => {
  return (
    <>
      <Card>
        <CardItem>
          {map(patients, ({ firstName, lastName, birthdate, isPrimary }, i) => {
            const styledBirthdate = moment.utc(birthdate).format('YYYY-MM-DD');
            const hasDefaultBirthDate = styledBirthdate === DEFAULT_BIRTHDATE;
            return (
              <div className={classNames(styles.patientItem)} key={`${firstName}-${i}`}>
                <h2 className={classNames('pb-0', styles.overflowEllipsis)}>
                  {firstName} {lastName}
                </h2>
                <p className={styles.capsuleGreen55}>
                  {hasDefaultBirthDate ? 'No Date of Birth' : moment(styledBirthdate).format('MM/DD/YYYY')}
                </p>
                {isPrimary && (
                  <div>
                    <br />
                    <p className={styles.capsuleBlue50}>{email}</p>
                    <p className={styles.capsuleBlue50}>{formatPhoneNumber(phone)}</p>
                  </div>
                )}
              </div>
            );
          })}
        </CardItem>
        {showFamilyPrompt && <NoFamilyPrompt />}
      </Card>
      {!showFamilyPrompt && <FamilyMemberTooltip />}
      <LinkButton
        to={AccountPageAddDependent.toPath()}
        style="secondary"
        size="medium"
        block
        data-cy="add-family-member"
      >
        add family member
      </LinkButton>
    </>
  );
};
